import { Space, Typography, Form, DatePicker } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartLine } from '@fortawesome/pro-solid-svg-icons'
import { SeasonStepProps } from '../../types'
import { calculateWorkingWeeks } from '../../budgetBuilderModel'
import { checkField } from '../../inputSanityModel'
import InputWarning from '../InputWarning'
import BandSliderInput from '../BandSliderInput'
import { SLIDER_TRACKS } from '../../bandSliderModel'
import './StepFieldRow.css'

const { Title, Paragraph } = Typography

export const SeasonStep = ({ data, onChange }: SeasonStepProps) => {
  const workingWeeks = data.seasonStartDate !== null && data.seasonEndDate !== null
    ? calculateWorkingWeeks(data.seasonStartDate, data.seasonEndDate)
    : null
  const seasonWarning = checkField('workingWeeks', workingWeeks)
  const crewHoursWarning = checkField('crewHoursPerWeek', data.hoursPerWeek)

  return (
    <Space
      direction="vertical"
      size="large"
      style={{
        width: '100%',
        maxWidth: '800px',
        padding: '40px 20px'
      }}
    >
      <div style={{
        backgroundColor: 'white',
        padding: '32px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <Space direction="horizontal" size="middle" style={{ marginBottom: '16px' }}>
          <FontAwesomeIcon icon={faChartLine} style={{ fontSize: '24px', color: '#ff6b4a' }} />
          <Title level={3} style={{ margin: 0 }}>Your Season</Title>
        </Space>

        <Paragraph style={{ color: '#666', marginBottom: '32px' }}>
          Define your working season and schedule.
        </Paragraph>

        <Form layout="vertical">
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Space className="step-field-row" direction="horizontal" size="large" style={{ width: '100%', alignItems: 'flex-start' }}>
              <Form.Item
                label="Your Average Season Start Date"
                required
                style={{ flex: 1, marginBottom: 0 }}
              >
                <DatePicker
                  value={data.seasonStartDate}
                  onChange={(date) => onChange('seasonStartDate', date)}
                  format="MMMM D, YYYY"
                  style={{ width: '100%' }}
                  size="large"
                  placeholder="Select date"
                />
              </Form.Item>

              <Form.Item
                label="You Average Season End Date"
                required
                style={{ flex: 1, marginBottom: 0 }}
              >
                <DatePicker
                  value={data.seasonEndDate}
                  onChange={(date) => onChange('seasonEndDate', date)}
                  format="MMMM D, YYYY"
                  style={{ width: '100%' }}
                  size="large"
                  placeholder="Select date"
                />
              </Form.Item>
            </Space>

            <InputWarning warning={seasonWarning} />

            <Space className="step-field-row" direction="horizontal" size="large" style={{ width: '100%', alignItems: 'flex-start' }}>
              <Form.Item
                label="How many days per week does your crew work?"
                required
                style={{ flex: 1, marginBottom: 0 }}
              >
                <BandSliderInput
                  value={data.daysPerWeek}
                  onChange={(value) => onChange('daysPerWeek', value)}
                  track={SLIDER_TRACKS.crewDaysPerWeek}
                  unit="number"
                  valueSuffix="days a week"
                  allowCustom={false}
                />
              </Form.Item>

              <Form.Item
                label="How many hours a week does each crew member work on average?"
                required
                style={{ flex: 1, marginBottom: 0 }}
              >
                <BandSliderInput
                  value={data.hoursPerWeek}
                  onChange={(value) => onChange('hoursPerWeek', value)}
                  track={SLIDER_TRACKS.crewHoursPerWeek}
                  unit="number"
                  valueSuffix="hours a week"
                  placeholder="40"
                  helpText="Average hours per crew member — full-timers and part-timers together"
                  warning={crewHoursWarning}
                  warnOnTrack
                />
              </Form.Item>
            </Space>
          </Space>
        </Form>
      </div>
    </Space>
  )
}
